<template>
    <v-popover>
        <slot></slot>
        <div id="menu" slot="popover"><slot name="items"></slot></div>
    </v-popover>
</template>

<script>
export default {};
</script>

<style lang="scss">
#menu {
    > ul {
        margin: 0;
        padding: 0 0 8px 0;
        background-color: #f4f4f4;

        > li {
            list-style: none;
            padding: 0.65rem 1.7rem;
            min-height: 29px;
            text-transform: uppercase;
            font-size: 12px;
            font-family: Roboto, sans-serif;
            min-width: 180px;
            text-align: center;
            cursor: pointer;

            + li {
                margin-top: 1px;
            }
        }

        > hr {
            border-bottom: 1px solid #a9a9a9;
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// popup-menu.vue?3853291e